(function() {
  'use strict';
  // Directive for expanding a main menu item when a page of the containing sub menu item is open
  angular.module('ringbaPortal').directive('trSubmenuExpand', trSubmenuExpand);

  function trSubmenuExpand (
    $timeout
  ) {
    const directive = {
      restrict: 'A',
      scope: {
        expandOn: '='
      },
      link: link
    };
    return directive;

    function link(scope, element) {
      // Check after element has been rendered
      $timeout(function () {
        if (element.hasClass('active')) {
          scope.expandOn = true;
        }
      });
    }
  }
})();
